import { useQuery } from "@tanstack/react-query";
import { PMTiles } from "pmtiles";

import { getRanaApiV1 } from "@nens/rana/api-v1";

// Single

const getPmTilesHeaderQuery = (url?: string) => {
  return getRanaApiV1().getQueryOptions({
    ignoreTenant: true,
    queryKey: ["pm-tiles-header", url],
    queryFn: async () => {
      const pmTiles = new PMTiles(url + "");
      return await pmTiles.getHeader();
    },
    enabled: !!url,
  });
};

export const usePmTilesHeaderQuery = (url?: string) => {
  return useQuery(getPmTilesHeaderQuery(url));
};
